export const headerConstant = {
    LIST_SUB_MENU: 'listSubMenu',
    DEFAULT_MODULE: '/ds-bao-cao-scyk',
    AUTHORITIES : "authorities",
    LIST_MENU: "listMenu",
};